import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { rem, getResetByTag } from './../../../styles';
var alertButtonContainerStyles = function alertButtonContainerStyles() {
  return /*#__PURE__*/css("align-items:center;display:inline-flex;line-height:normal;position:absolute;right:", rem(8), ";top:", rem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:alertButtonContainerStyles;"));
};
var resetStyles = getResetByTag('div');
var StyledAlertBtnContainer = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e5fopwm0"
} : {
  target: "e5fopwm0",
  label: "StyledAlertBtnContainer"
})(resetStyles, alertButtonContainerStyles);
export default StyledAlertBtnContainer;